<script lang="ts" setup>
import { computed } from "vue";
import type { PropType } from "vue";
import FiveStars from "@/components/molecules/other/FiveStars.vue";
import { EvaluationByOffice } from "@/types/order/EvaluationByOffice";
import { evaluationRound } from "@/utils/evaluationRound";

const props = defineProps({
  evaluation: {
    type: Object as PropType<EvaluationByOffice>,
    default: () => ({
      scorePunctuality: 0,
      scoreGreeting: 0,
      scoreCommunication: 0,
      scoreSkill: 0,
      scorePerformance: 0,
      avgEvaluation: 0
    })
  }
});

const filledStarImageSrc = computed(() =>
  require("@/assets/svg/star/filled_star_yellow.svg")
);
const filledStarHalfImageSrc = computed(() =>
  require("@/assets/svg/star/filled_star_half_yellow.svg")
);
const average = computed(() => {
  const avgEvaluation = props.evaluation.avgEvaluation;
  return evaluationRound(avgEvaluation);
});
</script>

<template>
  <div class="bg-gray-01 px-3 py-2 mt-2 round-4">
    <div class="total-score d-flex align-items-center">
      <p class="score-label text-mild text-size-12">総合評価</p>
      <FiveStars
        :filled-star-image-src="filledStarImageSrc"
        :filled-star-half-image-src="filledStarHalfImageSrc"
        :value="average"
        size="20"
      />
      <p class="score-point text-mild text-size-12" data-testid="average">
        {{ average }}点
      </p>
    </div>
    <ul class="score-list border-top border-outline-color">
      <li class="d-flex align-items-center">
        <p class="score-label text-mild text-size-12">時間</p>
        <FiveStars :value="evaluation.scorePunctuality" size="14" />
        <p
          class="score-point text-mild text-size-12"
          data-testid="score-punctuality"
        >
          {{ evaluation.scorePunctuality }}点
        </p>
      </li>
      <li class="d-flex align-items-center">
        <p class="score-label text-mild text-size-12">遂行</p>
        <FiveStars :value="evaluation.scorePerformance" size="14" />
        <p
          class="score-point text-mild text-size-12"
          data-testid="score-performance"
        >
          {{ evaluation.scorePerformance }}点
        </p>
      </li>
      <li class="d-flex align-items-center">
        <p class="score-label text-mild text-size-12">挨拶</p>
        <FiveStars :value="evaluation.scoreGreeting" size="14" />
        <p
          class="score-point text-mild text-size-12"
          data-testid="score-greeting"
        >
          {{ evaluation.scoreGreeting }}点
        </p>
      </li>
      <li class="d-flex align-items-center">
        <p class="score-label text-mild text-size-12">コミュニケーション</p>
        <FiveStars :value="evaluation.scoreCommunication" size="14" />
        <p
          class="score-point text-mild text-size-12"
          data-testid="score-communication"
        >
          {{ evaluation.scoreCommunication }}点
        </p>
      </li>
      <li class="d-flex align-items-center">
        <p class="score-label text-mild text-size-12">スキル</p>
        <FiveStars :value="evaluation.scoreSkill" size="14" />
        <p class="score-point text-mild text-size-12" data-testid="score-skill">
          {{ evaluation.scoreSkill }}点
        </p>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.score-label {
  min-width: 112px;
  margin-right: 6px;
}

.score-point {
  margin-left: 6px;
}

.score-list {
  margin-top: 6px;

  li {
    padding-top: 6px;
    line-height: 1;
  }
}
</style>
